/**
 * catalog-grid-fillers.js
 *
 * Adds invisible filler items to the end of teaser grids so the last row
 * is visually complete.
 *
 * Supports:
 * 1) ul.catalog-teasers > li
 * 2) .view-open-access .view-content > .views-row
 * 
 * TODO: Refactor teaser Twig so all contexts use the same wrapper/item markup; then simplify grid-filler JS/CSS.
 * 
 */
(function (Drupal, once) {
  console.log("Grid-Filler loaded!");

  function install(container, config) {
    let scheduled = false;
    let retryTimer = 0;
    let retriesLeft = 0;

    function getColCount() {
      const gtc = getComputedStyle(container).gridTemplateColumns;
      if (!gtc || gtc === "none") return 0;
      return gtc.trim().split(/\s+/).length;
    }

    function getChildren() {
      return Array.from(container.children);
    }

    function isRealItem(el) {
      if (el.classList.contains("grid-filler")) return false;
      return !!el.querySelector(config.realItemQuery);
    }

    function countRealItems() {
      return getChildren().filter(isRealItem).length;
    }

    function removeFillers() {
      getChildren()
        .filter((el) => el.classList.contains("grid-filler"))
        .forEach((el) => el.remove());
    }

    function setFillers(needed) {
      removeFillers();

      if (needed > 0) {
        const frag = document.createDocumentFragment();

        for (let i = 0; i < needed; i++) {
          const filler = document.createElement(config.fillerTag);
          filler.className = config.fillerClass;
          filler.setAttribute("aria-hidden", "true");
          frag.appendChild(filler);
        }

        container.appendChild(frag);
      }
    }

    function update() {
      scheduled = false;

      if (!container.isConnected) return;

      const cs = getComputedStyle(container);
      if (cs.display !== "grid" && cs.display !== "inline-grid") {
        retry();
        return;
      }

      const cols = getColCount();
      if (!cols) {
        retry();
        return;
      }

      const real = countRealItems();
      const needed = real === 0 ? 0 : (cols - (real % cols)) % cols;
      const existing = getChildren().filter((el) =>
        el.classList.contains("grid-filler")
      ).length;

      if (existing !== needed) {
        setFillers(needed);
      }

      container.classList.add("is-fillers-ready");
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    }

    function retry() {
      if (retryTimer || retriesLeft <= 0) return;
      retryTimer = setTimeout(() => {
        retryTimer = 0;
        retriesLeft--;
        schedule();
      }, 60);
    }

    function trigger() {
      retriesLeft = 16;
      schedule();
    }

    const ro = new ResizeObserver(trigger);
    ro.observe(container);
    trigger();
  }

  Drupal.behaviors.catalogGridFillers = {
    attach(context) {
      once("catalog-grid-fillers", "ul.catalog-teasers", context).forEach((ul) =>
        install(ul, {
          fillerTag: "li",
          fillerClass: "grid-filler",
          realItemQuery: ":scope > a > article",
        })
      );

      once(
        "catalog-grid-fillers",
        ".view-open-access .view-content",
        context
      ).forEach((viewContent) =>
        install(viewContent, {
          fillerTag: "div",
          fillerClass: "views-row grid-filler",
          realItemQuery: ":scope > a > article",
        })
      );

      once(
        "catalog-grid-fillers",
        ".views-field-books-and-editions-by-person .item-list ul",
        context
      ).forEach((viewContent) =>
        install(viewContent, {
          fillerTag: "div",
          fillerClass: "views-row grid-filler",
          realItemQuery: ":scope > a > article",
        })
      );
    },
  };
})(Drupal, once);
